import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "font-semibold" }
const _hoisted_2 = {
  preload: "none",
  controls: "",
  class: "w-64 h-10",
  controlslist: "nofullscreen nodownload noremoteplayback noplaybackrate foobar"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.anchorReply())),
    class: "flex flex-col rounded-lg p-2 mb-2 border-l-4 border-l-blue-400 bg-blue-600 text-white text-left cursor-pointer"
  }, [
    _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.getUserName), 1),
    _createElementVNode("audio", _hoisted_2, [
      _createElementVNode("source", { src: _ctx.messageAudio }, null, 8, _hoisted_3)
    ])
  ]))
}